import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import ScrollToTop from './components/ScrollToTop';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ContactPage from './pages/ContactPage';
import BrandsPage from './pages/BrandsPage';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCancel from './pages/CheckoutCancel';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminOverview from './pages/admin/AdminOverview';
import AdminProducts from './pages/admin/AdminProducts';
import AdminOrders from './pages/admin/AdminOrders';
import AdminMessages from './pages/admin/AdminMessages';
import AdminNewsletter from './pages/admin/AdminNewsletter';
import { CartProvider } from './context/CartContext';
import { Toaster } from './components/ui/toaster';

const Storefront = ({ children }) => (
  <CartProvider>
    <Header />
    <CartDrawer />
    <main className="min-h-screen bg-white">{children}</main>
    <Footer />
    <PWAInstallPrompt />
  </CartProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Storefront><HomePage /></Storefront>} />
          <Route path="/shop" element={<Storefront><ShopPage /></Storefront>} />
          <Route path="/product/:id" element={<Storefront><ProductDetailPage /></Storefront>} />
          <Route path="/contact" element={<Storefront><ContactPage /></Storefront>} />
          <Route path="/brands" element={<Storefront><BrandsPage /></Storefront>} />
          <Route path="/checkout/success" element={<Storefront><CheckoutSuccess /></Storefront>} />
          <Route path="/checkout/cancel" element={<Storefront><CheckoutCancel /></Storefront>} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverview />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="messages" element={<AdminMessages />} />
            <Route path="newsletter" element={<AdminNewsletter />} />
          </Route>
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
